import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'

import EmployeeSectionImage from '../../assets/EmployeeSection/employee-section.png'

export const EmployeesPage = () => {
  const { t } = useTranslation()

  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Employees section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={EmployeeSectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
